"use client";
import React from "react";
import { Button } from "@cmp-src/primitives/button";
import { TacticLogo } from "@cmp-src/icons/TacticLogo/TacticLogo";
import { ExternalLink } from "@cmp-src/primitives/external-link";
import { useTeamsApp } from "@/features/microsoft-teams/hooks/useTeamsApp";
import { logError } from "@gettactic/helpers";
import { ThemeProvider } from "@gettactic/components/themes/ThemeProvider/ThemeProvider";

export const EmbeddedLoginScreen: React.FC = () => {
  const teamsClient = useTeamsApp();

  React.useEffect(() => {
    if (teamsClient) {
      teamsClient.app.notifySuccess();
    }
  }, [teamsClient]);

  const handleLogin = async (client: typeof teamsClient) => {
    if (client == null) {
      return;
    }

    client.authentication
      .authenticate({
        url: `${process.env.NEXT_PUBLIC_TACTIC_API_URL}/auth/login?returnUrl=${encodeURIComponent(
          `${process.env.NEXT_PUBLIC_TACTIC_DOMAIN_AND_PORT}/microsoft-teams/tab-auth-done`
        )}`,
        width: 600,
        height: 535
      })
      .then(() => {
        window.location.assign(
          `${(process.env.NEXT_PUBLIC_TACTIC_DOMAIN_AND_PORT || "").replace("https://", "https://app.")}`
        );
      })
      .catch((err: unknown) => {
        logError("Login failed: " + err);
      });
  };

  return (
    <ThemeProvider
      defaultBrand="base"
      storageKey="ui-theme-new"
      externalBrand="base"
    >
      <div
        className="flex h-screen w-screen flex-col items-center justify-center px-4"
        style={{
          background:
            "linear-gradient(295deg, rgba(209, 238, 237, 1) 0%, rgba(208, 227, 249, 1) 100%)"
        }}
      >
        <div className="flex w-full max-w-[500px] flex-col items-center rounded-[34px] bg-white/65 px-8 py-12 shadow-2xl md:px-12">
          <TacticLogo titleColor="#112140" logoColor="#00A7B3" />

          <div className="mt-10 flex flex-col text-center">
            <h3 className="text-3xl font-bold text-[#082F49]">
              Welcome to Tactic!
            </h3>
            <p className="mt-2 text-lg font-normal text-gray-500">
              Log in to access your interactive office map
            </p>
          </div>

          <div className="mt-10 flex w-full flex-col items-center">
            <Button onClick={() => handleLogin(teamsClient)}>
              <span className="text-lg">Log in</span>
            </Button>

            <p className="mt-6 text-sm text-gray-500">
              Don&apos;t have an account?{" "}
              <ExternalLink
                href="https://gettactic.com/signup"
                className="text-sm font-medium text-teal-600 underline"
              >
                Sign up
              </ExternalLink>
            </p>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};
